import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import PropertyCard from "../components/PropertyCard";
import CustomButton from "../components/CustomButton";
import Hero from "../sections/Hero";
import WhyUs from "../sections/WhyUs";
import Reviews from "../sections/Reviews";
import Inquiry from "../sections/Inquiry";
import "../assets/scss/pages/home.scss";

// Styles for Slider
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Home = () =>  {
    const API = process.env.REACT_APP_API_BASE_URL;
    const [featuredProperties, setFeaturedProperties] = useState([]);
    const [fetchFeedBack, setFetchFeedback] = useState({ success: null, message: ""});
    const [isLoading, setIsLoading] = useState(true);

    const fetchProperties = useCallback(async () => {
        try {
            const response = await fetch(`${API}/properties/?page_size=3`);
            if (!response.ok) {
                const errorData = await response.json();
                console.log(errorData);
                setFetchFeedback({ success: false, message: "Unable to load featured properties, please refresh page." });
            }

            const data = await response.json();
            setFeaturedProperties(data.results);

            setFetchFeedback({ success: true, message: "" });
        } catch (error) {
            console.log(`Error fetching featured properties: ${error.message}`);
            setFetchFeedback({ success: false, message: "An unexpected error has occured. Kindly refresh page." });
        } finally {
            setIsLoading(false);
        }
    }, [API]);

    useEffect(() => {
        fetchProperties();
    }, [fetchProperties]);

    return (
        <>
            <Container>
                {/* Hero Section */}
                <Hero />

                {/* Feature Section */}
                <Row as="section" className="home-section d-flex mx-auto">
                    <Row as="header">
                        <h2 className="py-3"><b>FEATURED</b> PROPERTIES</h2>
                        <p>Discover some of our finest listings</p>
                    </Row>
                    <Row as="section" xs={1} sm={1} md={2} lg={3} xl={3} xxl={3} className="properties gy-4 mx-auto mb-5 px-0">
                        {isLoading ? (
                            <div className="text-center mx-auto mt-5">
                                <Spinner animation="border" variant="primary" className="mx-auto" />
                                <p className="mt-2">Loading featured properties...</p>
                            </div>
                        ) : (
                            fetchFeedBack.success ? (
                                featuredProperties?.length > 0 &&
                                    (featuredProperties.map((property, index) => (
                                        <Col key={ index }>
                                            <PropertyCard property={ property } />
                                        </Col>
                                    )))
                                ) :
                                <p className="text-center mx-auto fw-semibold pt-5 text-danger">
                                    { fetchFeedBack.message }
                                </p>
                            )
                        }
                    </Row>
                    <CustomButton link="/properties" value="See More" />
                </Row>
            </Container>

            {/* Why Choose Us Section */}
            <WhyUs />

            <Container className="flex-grow-1">
                {/* Inquiry Section */}
                <Inquiry contactCardType="text"/>

                {/* Review Section */}
                <Reviews />
            </Container>
        </>
    );
};

export default Home;
